import { render, staticRenderFns } from "./office-page.vue?vue&type=template&id=5a5f6d66&"
import script from "./office-page.vue?vue&type=script&lang=ts&"
export * from "./office-page.vue?vue&type=script&lang=ts&"
import style0 from "./office-page.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports